import {
  WebSocketEvent,
  WebSocketEventData,
} from "../Models/WebSocketEventData";
import { useChecklistStore } from "../Stores/Checklist";
import { useTicketStore } from "../Stores/Ticket";

export const handleWebSocketEvent = (
  event: string,
  data: WebSocketEventData
) => {
  // Send event to target
  switch (event) {
    case WebSocketEvent.BUG_TYPING:
    case WebSocketEvent.BUG_UPDATED:
    case WebSocketEvent.BUG_CREATED:
    case WebSocketEvent.MESSAGE_CREATED:
    case WebSocketEvent.MESSAGE_DELETED:
    case WebSocketEvent.BOT_OPENLINK:
    case WebSocketEvent.BOT_WRITTING:
    case WebSocketEvent.BOT_TOOL:
    case WebSocketEvent.BOT_STARTFEEDBACKFLOW:
    case WebSocketEvent.CUSTOMACTION_RUN:
      useTicketStore.getState().handleWebSocketEvent(data);
      break;

    case WebSocketEvent.CHECKLIST_UPDATED:
      useChecklistStore.getState().handleWebSocketEvent(data);
      break;

    default:
      break;
  }
};
